import NC from 'nc/NC'
import { FC } from 'react'
import AltBestListTemplate from 'shared-components/templates/AltBestListTemplate'
import { DSAltBestListPage } from 'shared-definitions/types'
import { DSNCAA } from 'types.aa.ds'

interface AltBestListTemplatePropsAA {
  page: DSAltBestListPage<DSNCAA>
}

const AltBestListTemplateAA: FC<AltBestListTemplatePropsAA> = ({ page }) => (
  <AltBestListTemplate page={page} nc={NC} />
)

export default AltBestListTemplateAA
